var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon_menu","transform":"translate(-1830.75 -51.75)"},[React.createElement("line",{"id":"Linie_42","data-name":"Linie 42","x2":"38","transform":"translate(1831.5 72.5)","fill":"none","stroke":"#2a2c2b","strokeLinecap":"round","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Linie_43","data-name":"Linie 43","x2":"38","transform":"translate(1831.5 62.5)","fill":"none","stroke":"#2a2c2b","strokeLinecap":"round","strokeWidth":"1.5","key":1}),React.createElement("line",{"id":"Linie_44","data-name":"Linie 44","x2":"38","transform":"translate(1831.5 52.5)","fill":"none","stroke":"#2a2c2b","strokeLinecap":"round","strokeWidth":"1.5","key":2})]));
}

IconMenu.defaultProps = {"width":"39.5","height":"21.5","viewBox":"0 0 39.5 21.5"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
